// 数据看板

import UltMeta, { Meta } from "./UltMeta/index";

class Scope extends UltMeta {
    TOTAL = new Meta(1, "全部");
    MONTH = new Meta(2, "近一月");
    QUARTER = new Meta(3, "近一季度");
    YEAR = new Meta(4, "近一年");
}

export const SCOPE = new Scope();
